"use client"

import React from "react"
import { signIn } from "next-auth/react"

import { twMerge } from "#lib/twMergeConfig"
import SvgGoogle from "#svgs/brand icons/Google"

export function ThirdPartyAuth({ className }: { className?: string }) {
  return (
    <section className={twMerge("flex w-full justify-center gap-4", className)}>
      <button
        className={"flex w-full cursor-pointer items-center justify-center gap-x-3.5 rounded-2xl border-[1px] border-gray-20 py-2.5 md:py-3.5"}
        onClick={() => signIn("google", { callbackUrl: "/account/profile" })}>
        <SvgGoogle className={"h-4.5 w-4.5"} />
        <span className={"hidden text-[13px] font-semibold xs:block 2xl:text-bg"}>Google</span>
      </button>
    </section>
  )
}
